import React, { useState } from "react";
import { FaSpinner, FaTrash, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { deletePayment, fetchPayment } from "../../../redux/slices/paymentSlice";

export default function DeleteShopperPayment({
  id,
  name,
  shopper_id,
  amount,
}) {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const status = useSelector((state) => state.payment?.deletePaymentStatus);
  const dispatch = useDispatch();

  const handleDelete = async () => {
    try {
      const res = await dispatch(deletePayment(id));
      if (res.payload) {
        toast.success(res.payload.message || "Payment deleted successfully.");
        dispatch(fetchPayment());
      }
    } catch (error) {
      toast.error("Failed to delete payment.");
      console.error(error);
    }

    setShowDeleteModal(false);
  };

  return (
    <>
      <div className="flex items-center">
        <button type="button" onClick={() => setShowConfirmModal(true)}>
          <FaTrash className="text-red-600 text-xl" />
        </button>
      </div>

      {showConfirmModal && (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto">
            <div className="relative w-auto max-w-3xl mx-auto">
              <div className="bg-white p-8 rounded-lg shadow-lg relative">
                <button
                  onClick={() => setShowConfirmModal(false)}
                  className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
                >
                  <FaTimes />
                </button>
                <div className="text-center">
                  <h2 className="text-xl font-medium text-gray-800 mb-2">
                    Are you sure?
                  </h2>
                  <p className="text-gray-600">
                    Do you really want to{" "}
                    <span className="font-semibold text-red-600">
                      delete this payment
                    </span>
                    ?
                  </p>
                </div>
                <div className="flex justify-center mt-6 gap-4">
                  <button
                    onClick={() => setShowConfirmModal(false)}
                    className="px-4 py-2 text-sm font-semibold text-gray-600 bg-gray-100 rounded-md"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      setShowConfirmModal(false);
                      setShowDeleteModal(true);
                    }}
                    className="px-4 py-2 text-sm font-semibold text-white bg-red-600 rounded-md"
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
        </>
      )}

      {showDeleteModal && (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto">
            <div className="relative w-auto max-w-3xl mx-auto">
              <div className="bg-white p-10 rounded-lg shadow-lg relative">
                <button
                  onClick={() => setShowDeleteModal(false)}
                  className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
                >
                  <FaTimes />
                </button>
                <div className="text-center">
                  <h2 className="text-xl font-medium text-gray-800 mb-2">
                    Confirm Delete
                  </h2>
                  <p className="text-gray-600">You are deleting this payment:</p>
                  <div className="mt-4 text-sm text-gray-700 space-y-1">
                    <p>
                      <strong>Shopper:</strong> {name}
                    </p>
                    <p>
                      <strong>Amount:</strong>{" "}
                      <span className="font-bold">&#8358;{amount}</span>
                    </p>
                  </div>
                </div>
                <div className="flex justify-center mt-6 gap-4">
                  <button
                    onClick={() => setShowDeleteModal(false)}
                    className="px-4 py-2 text-sm font-semibold text-gray-600 bg-gray-100 rounded-md"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleDelete}
                    disabled={status === "loading"}
                    className="flex items-center gap-2 px-4 py-2 text-sm font-semibold text-white bg-red-600 rounded-md"
                  >
                    {status === "loading" ? (
                      <>
                        <FaSpinner className="animate-spin" />
                        Deleting...
                      </>
                    ) : (
                      <>
                        <FaTrash />
                        Delete Payment
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
        </>
      )}
    </>
  );
}
